// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"e892de2f","787":"c8de6e26"}[chunkId] + ".chunk.js";
};